import { useCallback, useEffect, useState } from 'react'
import { isExporting, runExportJob, subscribeExporting } from './runExportJob'

/**
 * Wrapper của `runExportJob` cho function component: trả về sẵn state `exporting`
 * để nối vào `disabled` / `loading` của nút Export.
 *
 * `exporting` được DERIVE từ khoá in-flight cấp module chứ không tự quản lý riêng.
 * Lý do: component có thể unmount rồi mount lại giữa lúc request còn đang bay
 * (ModalDetailStaticsItem render có điều kiện `{isOpen && ...}` nên đóng modal là unmount
 * thật). Nếu giữ state riêng, instance mới sẽ có `exporting = false` và nút Export trông như
 * sẵn sàng, bấm vào chỉ nhận toast "đang tạo job" — UI nói dối tới khi request cũ xong.
 *
 * Unsubscribe trong cleanup cũng loại luôn nguy cơ setState sau unmount.
 *
 * Class component không dùng hook được — gọi trực tiếp `runExportJob` và tự quản lý state
 * (xem ExportOrders.js, ListItemsFilter.js, StaticsCutoffPage.js).
 *
 * @param key - Định danh loại export, vd 'users-statics:export'
 */
export default function useExportJob(key) {
    const [exporting, setExporting] = useState(() => isExporting(key))

    useEffect(() => {
        const sync = () => setExporting(isExporting(key))

        // Đồng bộ ngay: khoá có thể đã đổi giữa lúc render và lúc effect chạy, hoặc `key` vừa đổi
        sync()

        return subscribeExporting(sync)
    }, [key])

    const startExport = useCallback(
        (callApi, options) => runExportJob(key, callApi, options),
        [key]
    )

    return { exporting, startExport }
}
